import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../shared/services/toast.service';
import { StationService } from '../../../shared/services/http/station/station.service';

@Component({
  selector: 'app-edit-table',
  templateUrl: './edit-table.component.html',
  styleUrls: ['./edit-table.component.scss'],
})
export class EditTableComponent implements OnInit {
  public tableForm: FormGroup | any;
  isLoading = false;
  @Input() public editData: any;

  constructor(
    public modal: NgbActiveModal,
    private fb: FormBuilder,
    private stationService: StationService,
    private toastService: ToastService,
  ) {}
  ngOnInit() {
    this.tableForm = this.fb.group({
      object_nbr: ['', Validators.required],
      num_chair: ['', Validators.required],
    });
    console.log('edit data', this.editData);

    if(this.editData ){
      this.tableForm.get('num_chair').setValue(this.editData.num_chair);
      this.tableForm.get('object_nbr').setValue(this.editData.object_nbr);
    }
  }

  onSubmit() {
    this.isLoading = true;
    this.editData.num_chair = Number(this.tableForm.get('num_chair').value);
    this.editData.object_nbr = Number(this.tableForm.get('object_nbr').value);
    const $obs = this.stationService.updateStationObjectById(this.editData._id, this.editData).subscribe({
      next: (tag: any) => {
        this.isLoading = false;
        this.toastService.show('Updated!', 'Your Table is successfully updated.', { classNames: ['bg-success'] });
        this.modal.close(true);
      },
      error: (err: Error) => {
        this.isLoading = false;

        this.modal.close(true);
        this.toastService.show('Error!', err, { classNames: ['bg-danger', 'text-white'] });
      },
      complete: () => {
        this.isLoading = false;
        this.modal.close(true);
        $obs.unsubscribe();
      },
    });
  }
}
